<script setup lang="ts">
import type { DSTopic } from '@/types'

const props = defineProps({
  topic: {
    type: Object as PropType<DSTopic>,
    required: true,
  },
})
const localePath = useLocalePath()
const { $tracker } = useNuxtApp()
const resizedImage = ref('')
resizedImage.value = await getResizeUrl(props.topic.coverImage, props.topic.id)

function trackEvent() {
  $tracker('view_topic', { id: props.topic.id })
}
</script>

<template>
  <nuxt-link
    :to="localePath(`/topics/${topic.id}`)" class="mr-4 w-[200px] h-[200px]"
    track-component="nav-topic-card"
    @click="trackEvent"
  >
    <div
      class="flex w-full h-full rounded-full flex-col-reverse bg-cover"
      :style="{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${resizedImage})`,
      }"
    >
      <h5 class="py-4 text-white font-handwriting px-3">
        {{ topic.title }}
      </h5>
    </div>
  </nuxt-link>
</template>
